<template>
  <div id="wrapper__inner">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    bgColors() {
      return this.$store.state.bgColors;
    }
  },

  watch: {
    bgColors(val) {
      this.addBgColors();
    }
  },

  mounted() {
    document.getElementById("wrapper").className += " splash";
    if (this.bgColors) {
      this.addBgColors();
    }
  },

  methods: {
    addBgColors() {
      let wrapper = document.getElementById("wrapper");
      wrapper.style.background =
        "linear-gradient(-45deg, " +
        this.bgColors[0] +
        " 0%, " +
        this.bgColors[1] +
        " 100%)";
    },

    removeBgColors() {
      let wrapper = document.getElementById("wrapper");
      wrapper.style.background = "initial";
    }
  },

  beforeRouteLeave(to, from, next) {
    document.getElementById("wrapper").classList.remove("splash");
    this.removeBgColors();
    next();
  }
};
</script>
